export default {
	StateBudgets: function(state) {
		return state.StateBudgets;
	},
	Total: function(state) {
		return state.Total;
	},
	StateBudgetsLoaded: function(state) {
		return state.StateBudgetsLoaded;
	}
};
